import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false,
    subCategorylist: null,
    subCategoryloading: false
}

export const categoryListAll = createAsyncThunk('/category/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getCategory(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const subcategorySubListAll = createAsyncThunk('/category/subcategoryList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getCategory(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const categorySubListAll = createAsyncThunk('/category/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getCategory(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})




export const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {

        categoryList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(categoryListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(categoryListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(categorySubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(categorySubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
            .addCase(subcategorySubListAll.pending, (state) => {

                state.subCategoryloading = false
            })
            .addCase(subcategorySubListAll.fulfilled, (state, action) => {
                state.subCategoryloading = true
                state.subCategorylist = action.payload
            })
    },
})

export const {
    categoryList


} = categorySlice.actions

export default categorySlice.reducer